export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.enterFullscreen': '进入全屏',
  'component.exitFullscreen': '退出全屏',
  'component.todo.title': '待处理任务',
  'component.todo.soundOn': '语音提醒已开启',
  'component.todo.soundOff': '语音提醒已关闭',
  'component.todo.pending': '待处理',
  'component.todo.processing': '去处理',
  'component.todo.withdrawAudit': '会员出款',
  'component.todo.activityAudit': '活动审核',
  'component.todo.smsBalance': '短信余额不足',
};
